const _prefix = '@disclosure/';

export default {
  GET_DISCLOSURE_TOP_REQUEST: _prefix + 'GET_DISCLOSURE_TOP_REQUEST',
  GET_DISCLOSURE_TOP_SUCCESS: _prefix + 'GET_DISCLOSURE_TOP_SUCCESS',
  GET_DISCLOSURE_TOP_ERROR: _prefix + 'GET_DISCLOSURE_TOP_ERROR',

  GET_SECTION_DETAIL_REQUEST: _prefix + 'GET_SECTION_DETAIL_REQUEST',
  GET_SECTION_DETAIL_SUCCESS: _prefix + 'GET_SECTION_DETAIL_SUCCESS',
  GET_SECTION_DETAIL_ERROR: _prefix + 'GET_SECTION_DETAIL_ERROR',

  GET_SECTION_TABLE_HEADING_REQUEST: _prefix + 'GET_SECTION_TABLE_HEADING_REQUEST',
  GET_SECTION_TABLE_HEADING_SUCCESS: _prefix + 'GET_SECTION_TABLE_HEADING_SUCCESS',
  GET_SECTION_TABLE_HEADING_ERROR: _prefix + 'GET_SECTION_TABLE_HEADING_ERROR',

  GET_PATIENT_GROUP_TOP_REQUEST: _prefix + 'GET_PATIENT_GROUP_TOP_REQUEST',
  GET_PATIENT_GROUP_TOP_SUCCESS: _prefix + 'GET_PATIENT_GROUP_TOP_SUCCESS',
  GET_PATIENT_GROUP_ERROR: _prefix + 'GET_PATIENT_GROUP_ERROR',

  DO_SEARCH_REQUEST: _prefix + 'DO_SEARCH_REQUEST',
  DO_SEARCH_SUCCESS: _prefix + 'DO_SEARCH_SUCCESS',
  DO_SEARCH_ERROR: _prefix + 'DO_SEARCH_ERROR',

  UPDATE_QUERIES: _prefix + 'UPDATE_QUERIES'
};
